import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { authGuardFn, AuthService } from '@auth0/auth0-angular';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const router = inject(Router);

  if (environment.outage) {
    return router.createUrlTree(['/outage']);
  }

  return authGuardFn(route, state);
};

export const notOutageGuard: CanActivateFn = (): boolean | UrlTree => {
  const router = inject(Router);

  if (environment.outage) {
    return router.createUrlTree(['/outage']);
  }

  return true;
};

export const outageGuard: CanActivateFn = (): boolean | UrlTree => {
  const router = inject(Router);

  if (!environment.outage) {
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean | UrlTree {
    if (environment.outage) {
      return this.router.createUrlTree(['/outage']);
    }

    this.authService.isAuthenticated$.subscribe(isAuthenticated => {
      if (isAuthenticated) return  true;
      this.authService.loginWithRedirect();
      return false;
    });

    return true;
  }
}